/* global axios */

export const getAccountDomain = accountId =>
  axios.get(`/api/v1/accounts/${accountId}/account_domain`);

export const updateAccountDomain = (accountId, hostname) =>
  axios.put(`/api/v1/accounts/${accountId}/account_domain`, { hostname });

export const removeAccountDomain = accountId =>
  axios.delete(`/api/v1/accounts/${accountId}/account_domain`);
